export function calcularResumenMunicipios(filas) {
  const resumen = {};

  filas.forEach((f) => {
    if (!resumen[f.municipio]) {
      resumen[f.municipio] = {
        municipio: f.municipio,
        total: 0,
        variaciones: [],
      };
    }

    resumen[f.municipio].total += f.valor;
    resumen[f.municipio].variaciones.push(f.variacion);
  });

  return Object.values(resumen).map((r) => {
    const promedioVariacion = Number(
      (
        r.variaciones.reduce((a, b) => a + b, 0) /
        r.variaciones.length
      ).toFixed(2)
    );

    let tendencia = "ESTABLE";
    if (promedioVariacion > 5) tendencia = "CRECIENTE";
    if (promedioVariacion < -5) tendencia = "DECRECIENTE";

    return {
      municipio: r.municipio,
      total: r.total,
      promedioVariacion,
      tendencia,
    };
  });
}
